import { Box, Stack } from '@mui/material';
import { colors, IconButton, Typography } from '@sweep-io/sweep-design';
import { Close as CloseIcon } from '@sweep-io/sweep-design/dist/icons/Close';
import { ReactNode } from 'react';
import { globalSearchSx } from '../pages/canvas-pages/canvasPanelConsts';
import { PAGE_SIDE_PADDING } from '../../constants';

const GroupsTerritoriesLayout = ({
  isDialogLayout,
  renderContent,
  renderDialogs,
  newButtonJsx,
  onClose,
  countText,
  searchJsx,
  title,
}: {
  isDialogLayout?: boolean;
  renderContent: () => ReactNode;
  renderDialogs: () => ReactNode;
  newButtonJsx: ReactNode;
  onClose?: () => void;
  countText: string;
  searchJsx: ReactNode;
  title: string;
}) => {
  return (
    <>
      <Stack
        height="100%"
        gap={2}
        sx={{
          padding: isDialogLayout ? undefined : `0 ${PAGE_SIDE_PADDING}px`,
        }}
      >
        {isDialogLayout && (
          <Stack gap={2}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h1">{title}</Typography>
              <Box display="flex" gap={1} alignItems="center">
                {newButtonJsx}
                <IconButton variant="flat" onClick={onClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={globalSearchSx(true)}
            >
              <Typography variant="body" color={colors.grey[700]}>
                {countText}
              </Typography>
              {searchJsx}
            </Box>
          </Stack>
        )}
        {!isDialogLayout && (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={globalSearchSx(true)}
          >
            {searchJsx}
            {newButtonJsx}
          </Box>
        )}
        {renderContent()}
      </Stack>
      {renderDialogs()}
    </>
  );
};

export default GroupsTerritoriesLayout;
